import React, { useState } from 'react';
import { View } from '@uncinc/react-drupal-core';

const ParagraphCatalog = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState({});

  return (
    <View
      id="catalogus"
      display="block_1"
      page={currentPage}
      filters={filters}
      setFilters={setFilters}
      setCurrentPage={setCurrentPage}
    />
  );
};

export default ParagraphCatalog;
